import { render, staticRenderFns } from "./listSix.vue?vue&type=template&id=ff0f5776&scoped=true"
import script from "./listSix.vue?vue&type=script&lang=js"
export * from "./listSix.vue?vue&type=script&lang=js"
import style0 from "./listSix.vue?vue&type=style&index=0&id=ff0f5776&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0f5776",
  null
  
)

export default component.exports